import { render } from "./GestionUsuariosView.vue?vue&type=template&id=41b1411a&scoped=true"
import script from "./GestionUsuariosView.vue?vue&type=script&lang=js"
export * from "./GestionUsuariosView.vue?vue&type=script&lang=js"

import "./GestionUsuariosView.vue?vue&type=style&index=0&id=41b1411a&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b1411a"]])

export default __exports__